import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// Actions
import { getAllInterests } from "~/actions/interests";
import { fetchProfileData, uploadProfilePicture } from "~/actions/profiles";
import { updateSessionUser, removeSession } from "~/actions/sessions";
import { getSubscription } from "~/actions/subscriptions";

// Components
import { MetaData } from "~/components";
import { ActionButtons, Body, Header, Loading, Onboarding } from "./components";

class Profile extends React.Component {
  state = {
    tab:
      typeof window !== "undefined" && window.location.hash
        ? window.location.hash.substring(1)
        : "profile",
    editing_fields: false,
    changed_fields: {
      profile_picture: {},
      core: {},
      custom: {}
    }
  };

  componentWillMount() {
    this.props.fetchProfileData(this.props.match.params.user_id);
    this.props.getAllInterests();
    if (
      !("user_id" in this.props.match.params) &&
      this.props.session.sessionsAllowed
    )
      this.props.getSubscription();
  }

  /*componentWillUpdate(nextProps, nextState) {
		let nextUser = nextProps.session.user,
			fetching = nextProps.session.fetching.user;
	}*/

  toggleEditFields = () => {
    if (this.state.editing_fields) this.submitUpdatedField();
    this.setState({
      editing_fields: !this.state.editing_fields
    });
  };

  addUpdateField = (field_type, field_key, value) => {
    const new_changed_fields = this.state.changed_fields;
    new_changed_fields[field_type][field_key] = value;
    this.setState({
      changed_fields: new_changed_fields
    });
  };

  removeUpdateField = (field_type, field_key) => {
    const new_changed_fields = this.state.changed_fields;
    if (!new_changed_fields[field_type][field_key]) return;
    delete new_changed_fields[field_type][field_key];
    this.setState({
      changed_fields: new_changed_fields
    });
  };

  submitUpdatedField = () => {
    if (this.state.changed_fields.profile_picture.hasOwnProperty("image")) {
      this.props.uploadProfilePicture(
        this.state.changed_fields.profile_picture.image
      );
    }

    if (
      Object.keys(this.state.changed_fields.core).length === 0 &&
      Object.keys(this.state.changed_fields.custom).length === 0
    )
      return;

    this.props.updateSessionUser(
      this.state.changed_fields.core,
      this.state.changed_fields.custom
    );
  };

  changeTab = tab => {
    this.setState({ tab });
  };

  logout = () => {
    this.props.removeSession();
    this.props.history.push("/login#loggedout");
  };

  render() {
    const isSessionUser =
        !("user_id" in this.props.match.params) &&
        this.props.session.sessionsAllowed,
      user = isSessionUser ? this.props.session.user : this.props.profile.user,
      isUser = "ID" in user,
      fetchingProfile = this.props.profile.fetching,
      fetchingUser = !!fetchingProfile || !isUser;

    return (
      <div>
        <Onboarding {...this.props} />

        <div className="profile-wrapper ptop80 ptop40-xs">
          <div className="container">
            {!fetchingUser && <MetaData page="profile" vars={user} />}

            {!fetchingProfile && (
              <ActionButtons
                editing_fields={this.state.editing_fields}
                isSessionUser={isSessionUser}
                logout={this.logout}
                toggleEditFields={this.toggleEditFields}
                user={user}
                usersMatch={
                  !isSessionUser &&
                  this.props.session.user.ID === this.props.profile.user.ID
                }
              />
            )}

            {!fetchingUser ? (
              <Header
                session={this.props.session}
                isSessionUser={isSessionUser}
                profile={this.props.profile}
                user={user}
                addUpdateField={this.addUpdateField}
                removeUpdateField={this.removeUpdateField}
                editing_fields={this.state.editing_fields}
                changed_fields={this.state.changed_fields}
              />
            ) : (
              <Loading />
            )}

            {!fetchingUser && this.props.session.sessionsAllowed && (
              <Body
                user={user}
                isSessionUser={isSessionUser}
                addUpdateField={this.addUpdateField}
                editing_fields={this.state.editing_fields}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  session: state.session,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchProfileData,
      getAllInterests,
      getSubscription,
      uploadProfilePicture,
      removeSession,
      updateSessionUser
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/js/views/Profile/index.jsx